import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.array.filter";
import _toConsumableArray from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.map";
import { __rest } from "tslib";
import { selector as parseSelector } from 'vega-event-selector';
import { identity, isArray, stringValue } from 'vega-util';
import { forEachSelection, MODIFY, STORE, unitName, VL_SELECTION_RESOLVE, TUPLE } from '.';
import { dateTimeToExpr, isDateTime, dateTimeToTimestamp } from '../../datetime';
import { keys, varName } from '../../util';
import { isUnitModel } from '../model';
import { forEachTransform } from './transforms/transforms';
import { parseSelectionBinExtent } from './parse';
export function assembleInit(init) {
  var isExpr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var wrap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : identity;

  if (isArray(init)) {
    var assembled = init.map(function (v) {
      return assembleInit(v, isExpr, wrap);
    });
    return isExpr ? "[".concat(assembled.join(', '), "]") : assembled;
  } else if (isDateTime(init)) {
    if (isExpr) {
      return wrap(dateTimeToExpr(init));
    } else {
      return wrap(dateTimeToTimestamp(init));
    }
  }

  return isExpr ? wrap(JSON.stringify(init)) : init;
}
export function assembleUnitSelectionSignals(model, signals) {
  forEachSelection(model, function (selCmpt, selCompiler) {
    var _signals;

    var name = selCmpt.name;
    var modifyExpr = selCompiler.modifyExpr(model, selCmpt);

    (_signals = signals).push.apply(_signals, _toConsumableArray(selCompiler.signals(model, selCmpt)));

    forEachTransform(selCmpt, function (txCompiler) {
      if (txCompiler.signals) {
        signals = txCompiler.signals(model, selCmpt, signals);
      }

      if (txCompiler.modifyExpr) {
        modifyExpr = txCompiler.modifyExpr(model, selCmpt, modifyExpr);
      }
    });
    signals.push({
      name: name + MODIFY,
      on: [{
        events: {
          signal: selCmpt.name + TUPLE
        },
        update: "modify(".concat(stringValue(selCmpt.name + STORE), ", ").concat(modifyExpr, ")")
      }]
    });
  });
  return cleanupEmptyOnArray(signals);
}
export function assembleFacetSignals(model, signals) {
  if (model.component.selection && keys(model.component.selection).length) {
    var name = stringValue(model.getName('cell'));
    signals.unshift({
      name: 'facet',
      value: {},
      on: [{
        events: parseSelector('mousemove', 'scope'),
        update: "isTuple(facet) ? facet : group(".concat(name, ").datum")
      }]
    });
  }

  return cleanupEmptyOnArray(signals);
}
export function assembleTopLevelSignals(model, signals) {
  var hasSelections = false;
  forEachSelection(model, function (selCmpt, selCompiler) {
    var name = selCmpt.name;
    var store = stringValue(name + STORE);
    var hasSg = signals.filter(function (s) {
      return s.name === name;
    });

    if (hasSg.length === 0) {
      var resolve = selCmpt.resolve === 'global' ? 'union' : selCmpt.resolve;
      var isMulti = selCmpt.type === 'multi' ? ', true)' : ')';
      signals.push({
        name: selCmpt.name,
        update: "".concat(VL_SELECTION_RESOLVE, "(").concat(store, ", ").concat(stringValue(resolve)).concat(isMulti)
      });
    }

    hasSelections = true;

    if (selCompiler.topLevelSignals) {
      signals = selCompiler.topLevelSignals(model, selCmpt, signals);
    }

    forEachTransform(selCmpt, function (txCompiler) {
      if (txCompiler.topLevelSignals) {
        signals = txCompiler.topLevelSignals(model, selCmpt, signals);
      }
    });
  });

  if (hasSelections) {
    var hasUnit = signals.filter(function (s) {
      return s.name === 'unit';
    });

    if (hasUnit.length === 0) {
      signals.unshift({
        name: 'unit',
        value: {},
        on: [{
          events: 'mousemove',
          update: 'isTuple(group()) ? group() : unit'
        }]
      });
    }
  }

  return cleanupEmptyOnArray(signals);
}
export function assembleUnitSelectionData(model, data) {
  var dataCopy = _toConsumableArray(data);

  forEachSelection(model, function (selCmpt) {
    var init = {
      name: selCmpt.name + STORE
    };

    if (selCmpt.init) {
      var fields = selCmpt.project.items.map(function (proj) {
        var signals = proj.signals,
            rest = __rest(proj, ["signals"]);

        return rest;
      });
      var insert = selCmpt.init.map(function (i) {
        return assembleInit(i, false);
      });
      init.values = selCmpt.type === 'interval' ? [{
        unit: unitName(model, {
          escape: false
        }),
        fields: fields,
        values: insert
      }] : insert.map(function (i) {
        return {
          unit: unitName(model, {
            escape: false
          }),
          fields: fields,
          values: i
        };
      });
    }

    var contains = dataCopy.filter(function (d) {
      return d.name === selCmpt.name + STORE;
    });

    if (!contains.length) {
      dataCopy.push(init);
    }
  });
  return dataCopy;
}
export function assembleUnitSelectionMarks(model, marks) {
  forEachSelection(model, function (selCmpt, selCompiler) {
    marks = selCompiler.marks ? selCompiler.marks(model, selCmpt, marks) : marks;
    forEachTransform(selCmpt, function (txCompiler) {
      if (txCompiler.marks) {
        marks = txCompiler.marks(model, selCmpt, marks);
      }
    });
  });
  return marks;
}
export function assembleLayerSelectionMarks(model, marks) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = model.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var child = _step.value;

      if (isUnitModel(child)) {
        marks = assembleUnitSelectionMarks(child, marks);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return marks;
}
export function assembleSelectionScaleDomain(model, extent) {
  var name = extent.selection;
  var selCmpt = model.getSelectionComponent(name, varName(name));
  return {
    signal: parseSelectionBinExtent(selCmpt, extent)
  };
}

function cleanupEmptyOnArray(signals) {
  return signals.map(function (s) {
    if (s.on && !s.on.length) delete s.on;
    return s;
  });
}